import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./traineePortal.css";
import {
  todayInputValue,
  toDateInputValue,
  validateEducationDates,
  yearsFromTodayInputValue,
} from "./dateUtils";

const TraineeEducation = () => {
  const [universityName, setUniversityName] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [qualification, setQualification] = useState("");
  const [yearOfStarting, setYearOfStarting] = useState("");
  const [yearOfPassing, setYearOfPassing] = useState("");
  const [percentage, setPercentage] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [educationOptions, setEducationOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEducationOptions = async () => {
      try {
        const response = await AxiosInstance.get("companies/educations/");
        if (response.status === 200) {
          setEducationOptions(response.data);
        } else {
          setErrorMessage("Failed to fetch education options.");
        }
      } catch (error) {
        console.error("Error fetching education options:", error);
        setErrorMessage("Failed to fetch education options.");
      }
    };

    fetchEducationOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const traineeId = localStorage.getItem("traineeId");

    if (!traineeId) {
      setErrorMessage("Trainee ID is missing.");
      return;
    }

    const education = educationOptions.find(
      (option) => option.qualification === qualification
    );
    if (!education) {
      setErrorMessage("Please select a valid qualification.");
      return;
    }

    const dateError = validateEducationDates(yearOfStarting, yearOfPassing);
    if (dateError) {
      setErrorMessage(dateError);
      return;
    }

    const newEducation = {
      trainee: traineeId,
      education: education.education_id,
      specialization,
      college_name: collegeName,
      university: universityName,
      year_of_starting: toDateInputValue(yearOfStarting),
      year_of_passing: toDateInputValue(yearOfPassing),
      percentage_or_cgpa: parseFloat(percentage),
    };

    try {
      const response = await AxiosInstance.post(
        "companies/education",
        newEducation
      );
      if (response.status === 201) {
        alert("Education added successfully!");
        navigate(-1);
      } else {
        setErrorMessage("Something went wrong, please try again.");
      }
    } catch (error) {
      console.error("Error adding education:", error);
      setErrorMessage("Failed to add education.");
    }
  };

  const closeModal = () => navigate(-1);
  const today = todayInputValue();
  const passMax = yearsFromTodayInputValue(15);

  return (
    <div className="als-trainee-form-page">
      <div className="als-trainee-form-card">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="mb-0">Add Education</h2>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <form onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="alert alert-danger">{errorMessage}</div>
          )}

          <div className="mb-3">
            <label className="form-label">University Name</label>
            <input
              type="text"
              className="form-control"
              value={universityName}
              onChange={(e) => setUniversityName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">College Name</label>
            <input
              type="text"
              className="form-control"
              value={collegeName}
              onChange={(e) => setCollegeName(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Qualification</label>
            <select
              className="form-select"
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
              required
            >
              <option value="">Select Qualification</option>
              {educationOptions.map((education) => (
                <option
                  key={education.education_id}
                  value={education.qualification}
                >
                  {education.qualification}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Specialization</label>
            <input
              type="text"
              className="form-control"
              value={specialization}
              onChange={(e) => setSpecialization(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Year of Starting</label>
            <input
              type="date"
              className="form-control"
              value={yearOfStarting}
              max={today}
              onChange={(e) => {
                const next = e.target.value;
                setYearOfStarting(next);
                setErrorMessage("");
                if (yearOfPassing && next && yearOfPassing < next) {
                  setYearOfPassing("");
                }
              }}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Year of Passing</label>
            <input
              type="date"
              className="form-control"
              value={yearOfPassing}
              min={yearOfStarting || undefined}
              max={passMax}
              onChange={(e) => {
                setYearOfPassing(e.target.value);
                setErrorMessage("");
              }}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Percentage / CGPA</label>
            <input
              type="text"
              className="form-control"
              value={percentage}
              onChange={(e) => setPercentage(e.target.value)}
            />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary">
              Save Education
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TraineeEducation;
